// GET DISCOVERY LOCATIONS
export const GET_DISCOVERY_LOCATIONS = 'GET_DISCOVERY_LOCATIONS';
export const GET_DISCOVERY_LOCATIONS_SUCCESS = 'GET_DISCOVERY_LOCATIONS_SUCCESS';
export const GET_DISCOVERY_LOCATIONS_FAILED = 'GET_DISCOVERY_LOCATIONS_FAILED';
// DELETE DISCOVERY LOCATION
export const DELETE_DISCOVERY_LOCATION = 'DELETE_DISCOVERY_LOCATION';
export const DELETE_DISCOVERY_LOCATION_SUCCESS = 'DELETE_DISCOVERY_LOCATION_SUCCESS';
export const DELETE_DISCOVERY_LOCATION_FAILED = 'DELETE_DISCOVERY_LOCATION_FAILED';
